import React, {Component} from "react";
import {ToggleButton, ToggleButtonGroup} from "@mui/material";
import TileViewLayer from "./TileViewLayer";
import RescanLayer from "./RescanLayer";
import Take1Layer from "./Take1Layer";
import Black from "./Black";

class TileBackgroundLayers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedValue: 'tile',
            showLayer: {
                'tile': true,
                'rescanLayer': false,
                'postTake1Layer': false,
                'none': false
            }
        };
    }

    handleVisibilityChange = (event, newValue) => {
        this.id = newValue;
        if (newValue !== null) {

            this.setState({selectedValue: newValue});
            this.setState((prevState) => ({
                    showLayer: Object.keys(prevState.showLayer).reduce((acc, key) => {
                        acc[key] = key === newValue ? !prevState.showLayer[newValue] : false;
                        return acc;
                    }, {}),
                }),
                () => {
                    Object.keys(this.state.showLayer).forEach(key => {
                        this.props.map.getLayers().getArray().find(layer => layer.get('id') === key).setVisible(this.state.showLayer[key])
                    })
                });
        }
    };

    render() {
        return (
            <ToggleButtonGroup
                value={this.state.selectedValue}
                exclusive
                onChange={this.handleVisibilityChange}
            >
                <ToggleButton sx={{textTransform: 'capitalize', fontSize: 10, padding: 1}} value="black">
                    <Black {...this.props} />
                </ToggleButton>
                <ToggleButton sx={{textTransform: 'capitalize', fontSize: 10, padding: 1}} value="rescanLayer">
                    <RescanLayer {...this.props}/>
                </ToggleButton>
                <ToggleButton sx={{textTransform: 'capitalize', fontSize: 10, padding: 1}} value="postTake1Layer">
                    <Take1Layer {...this.props} />
                </ToggleButton>
                <ToggleButton sx={{textTransform: 'capitalize', fontSize: 10, padding: 1}} value="tile">
                    <TileViewLayer {...this.props}/>
                </ToggleButton>
            </ToggleButtonGroup>
        );
    }
}

export default TileBackgroundLayers;
